export default {
    drawer: null,
    color: 'success',
    image: '',
}
